import { NgStyle } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { MarkdownModule } from 'ngx-markdown';
import type { TailwindColor } from '../super-latex.model';

@Component({
  selector: 'dojo-square-box-label-overlay',
  standalone: true,
  imports: [MarkdownModule, NgStyle],
  template: `
    <div class="label-container" [ngStyle]="labelStyles()">
      <markdown [data]="text()" [inline]="true" katex [katexOptions]="katexOptions()" />
    </div>
  `,
  styles: `
    :host {
      display: inline-block;
    }

    .label-container {
      font-size: 0.75rem;
      line-height: 1.5;
      white-space: nowrap;
      border-radius: 0.375rem;
      padding: 0.25rem 0.5rem;
      border-width: 1px;
      border-style: solid;
    }
  `,
})
export class SquareBoxLabelOverlayComponent {
  readonly text = input.required<string>();
  readonly color = input<TailwindColor>('sky');
  readonly offset = input<{ x?: number; y?: number }>();
  readonly katexOptions = input({
    throwOnError: false,
    strict: 'warn' as const,
    trust: true,
  });

  readonly labelStyles = computed(() => {
    const color = this.color();
    const offset = this.offset();
    const styles: Record<string, string> = {
      backgroundColor: `var(--${color}-50)`,
      borderColor: `var(--${color}-500)`,
      color: `var(--${color}-600)`,
    };

    if (offset?.x || offset?.y) {
      styles['transform'] = `translate(${offset.x ?? 0}px, ${offset.y ?? 0}px)`;
    }

    return styles;
  });
}
